export const openedFilled = `&#9660;`;
export const opened = `&#9661;`;
export const closedFilled = ` &#9654;`;
export const closed = ` &#9655;`;
export const downCaret = `&#8964;`;
